import moment from 'moment'
import get from 'lodash/get'
import at from 'lodash/at'

export const SET_CONTRACT_FILTER = 'SET_CONTRACT_FILTER'

export function setContractFilterForLocation (locationId, contractId) {
  return {
    type: SET_CONTRACT_FILTER,
    payload: {
      locationId,
      contractId
    }
  }
}

export const SET_CURRENT_CONTRACT_FILTER = 'SET_CURRENT_CONTRACT_FILTER'

export function setCurrentContractFilterForLocation (locationId) {
  return (dispatch, getState) => {
    const existingContractId = get(getState(), `workTrackerFilters.${locationId}.contractId`)

    if (!existingContractId) {
      const today = moment()
      const location = getState().locations[locationId]
      const contracts = at(getState().contracts, location.contracts || [])

      const currentContract = contracts.find((contract) => {
        if (contract.startDate <= today && contract.endDate >= today) {
          return contract
        }
      })

      if (currentContract) {
        return dispatch(setContractFilterForLocation(locationId, currentContract.id))
      }
    }
  }
}

export const SET_AREA_TYPE_FILTER = 'SET_AREA_TYPE_FILTER'

export function setAreaTypeFilterForLocation (locationId, areaTypeId) {
  return {
    type: SET_AREA_TYPE_FILTER,
    payload: {
      locationId,
      areaTypeId
    }
  }
}

export const SET_SUB_LOCATION_FILTER = 'SET_SUB_LOCATION_FILTER'

export function setSubLocationFilterForLocation (locationId, subLocationId) {
  return {
    type: SET_SUB_LOCATION_FILTER,
    payload: {
      locationId,
      subLocationId
    }
  }
}

export const SET_SERVICE_FILTER = 'SET_SERVICE_FILTER'

// this function has a
export function setServiceFilterForLocation (locationId, serviceId) {
  return {
    type: SET_SERVICE_FILTER,
    payload: {
      locationId,
      serviceId,
      ...(serviceId && serviceId.length > 1) && { amountIds: undefined }
    }
  }
}

export const SET_AMOUNT_FILTER = 'SET_AMOUNT_FILTER'

export function setAmountFilterForLocation (locationId, amountIds) {
  return {
    type: SET_AMOUNT_FILTER,
    payload: {
      locationId,
      amountIds
    }
  }
}

export const SET_SORTING = 'SET_SORTING'

export function setSortingForLocation (locationId, sortingId) {
  return {
    type: SET_SORTING,
    payload: {
      locationId,
      sortingId
    }
  }
}

export const SET_DATE_PERIOD_FILTER = 'SET_DATE_PERIOD_FILTER'

export function setDatePeriodFilterForLocation (locationId, datePeriod) {
  return {
    type: SET_DATE_PERIOD_FILTER,
    payload: {
      locationId,
      datePeriod
    }
  }
}

export const SET_LAST_CLEANED_FILTER = 'SET_LAST_CLEANED_FILTER'

export function setLastCleanedFilterForLocation (locationId, lastCleaned) {
  return {
    type: SET_LAST_CLEANED_FILTER,
    payload: {
      locationId,
      lastCleaned
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/work-tracker-filters.js